export const POST_SALES_APARTMENT_CONTRACT = "POST_SALES_APARTMENT_CONTRACT";
export const POST_SALES_APARTMENT = "POST_SALES_APARTMENT";

